export default __webpack_public_path__ + "static/media/projector.1e10d16a.jpg";